export default __webpack_public_path__ + "static/media/Armguards of Robustness.271f6109.jpg";